import React from 'react';
import {
  ADMIN_MENU_ITEMS,
  CONTENT_MENU_ITEMS,
  CONTRACT_MENU_ITEMS,
  TOOLS_MENU_ITEMS,
  INGEST_MENU_ITEMS,
  META_DATA_STRUCTURE_MENU_ITEMS,
  REVENUE_MENU_ITEMS,
  SYNC_MENU_ITEMS,
  VENDOR_MENU_ITEMS,
} from 'constants/menu';
import { accountStore } from 'store/accountStore';

const ALL_MENU_ITEMS = [
  ...(VENDOR_MENU_ITEMS ?? []),
  ...(CONTENT_MENU_ITEMS ?? []),
  ...(META_DATA_STRUCTURE_MENU_ITEMS ?? []),
  ...(CONTRACT_MENU_ITEMS ?? []),
  ...(REVENUE_MENU_ITEMS ?? []),
  ...(INGEST_MENU_ITEMS ?? []),
  ...(SYNC_MENU_ITEMS ?? []),
  ...(TOOLS_MENU_ITEMS ?? []),
  // ADMIN(Profile / Action History)을 마지막에 포함한다. 도메인 메뉴가 하나도 없는 제한 계정
  // — 예: VN 전용 계정에 role이 아직 부여되지 않은 상태 — 이 `/login`으로 떨어져
  // "로그인은 성공했는데 로그인 화면이 다시 뜨는" 루프에 빠지는 것을 막는 최후 착지점이다.
  // 마지막에 두므로 도메인 메뉴가 있는 일반 계정의 착지 지점은 바뀌지 않는다.
  ...(ADMIN_MENU_ITEMS ?? []),
];

const extractPath = (item: unknown): string | null => {
  if (!item || typeof item !== 'object') return null;
  const label = (item as { label?: unknown }).label;
  if (!label || typeof label !== 'object') return null;
  const to = (label as { props?: { to?: unknown } }).props?.to;
  if (typeof to !== 'string') return null;
  return to.split('?')[0];
};

/**
 * 현재 사용자가 접근 가능한 첫 번째 메뉴의 경로를 반환.
 * 탐색 순서는 `getMenus()`가 반환한 키 순서를 따른다 — vendor·vietnam 같은 제한 계정은
 * 자기 도메인 메뉴가 앞에 오도록 `getMenus()`에서 정렬해 둔다.
 *
 * `/login` 반환은 인증된 사용자에게는 로그인 루프가 되므로 마지막 수단이다.
 * ADMIN_MENU_ITEMS(Profile)가 포함돼 있어 실제로는 거의 도달하지 않는다.
 */
export const getDefaultRoute = (): string => {
  const menus = accountStore.getMenus();
  for (const key of menus) {
    const item = ALL_MENU_ITEMS.find(i => i?.key === key);
    const path = extractPath(item);
    if (path) return path;
  }
  return '/login';
};
